import { Dispatch } from "redux";
import { setLoading } from "./global";
import VoucherService from "service/Voucher";
import { showMessage } from "utilities/helper";
import {
  ReleaseVoucherPayloadTypes,
  VoucherPayloadTypes,
} from "utilities/types/Voucher";
import { CatalogDescriptionPayloadTypes } from "utilities/types/CatalogDescription";

export const getAllVouchers =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant: number = 3
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_VOUCHER_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_VOUCHER",
      searchValue: search,
    });

    try {
      const data = await VoucherService.getAllVouchers(
        page,
        search,
        limit,
        filterTenant
      );

      dispatch(setLoading(false));
      dispatch({
        type: "SET_VOUCHER",
        value: data.catalogs,
      });
      dispatch({
        type: "SET_VOUCHER_PAGE",
        totalPage: !!data.catalogs.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.catalogs.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_VOUCHER_FILTER_PAGE",
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeVoucher =
  (form: VoucherPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await VoucherService.storeVoucher(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().voucherReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllVouchers(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateVoucher =
  (
    voucherId: string,
    form: VoucherPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await VoucherService.updateVoucher(voucherId, payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().voucherReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllVouchers(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteVoucher =
  (voucherId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await VoucherService.deleteVoucher(voucherId);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().voucherReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllVouchers(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateVoucherDescription =
  (form: CatalogDescriptionPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await VoucherService.updateVoucherDescription(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_DESCRIPTION", value: false });

      dispatch(
        getAllVouchers(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const releaseVoucher =
  (form: ReleaseVoucherPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await VoucherService.releaseVoucher(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });
      dispatch(getAllVouchers(currentPage, searchValue, limitPage, filterTenantPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
